import * as React from "react";
import { SVGProps, Ref, forwardRef } from "react";
function SvgFacebookAlt(props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="1.5em"
      height="1.5em"
      fill="none"
      viewBox="0 0 32 32"
      ref={ref}
      {...props}
    >
      <path
        fill="currentColor"
        d="M32 16C32 7.16786 24.8321 0 16 0C7.16787 0 0 7.16786 0 16C0 23.9917 5.84964 30.6158 13.5118 31.8022V20.6138H9.42533V16H13.5118V12.4737C13.5118 8.46961 15.8847 6.2451 19.5427 6.2451C21.2894 6.2451 23.1019 6.57466 23.1019 6.57466V10.4799H21.0917C19.0978 10.4799 18.4717 11.7322 18.4717 12.9845V15.9835H22.9207L22.2122 20.5973H18.4717V31.7858C26.1504 30.6158 32 23.9917 32 16Z"
      />
    </svg>
  );
}
const ForwardRef = forwardRef(SvgFacebookAlt);
export default ForwardRef;
ForwardRef.defaultProps = {
  "aria-hidden": true,
  focusable: "false",
  role: "img",
};
